import Vue from 'vue'
import App from './App.vue'
import dataV from '@jiaminghi/data-view'
import './css/index.css'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import {fitChartsize} from  '../src/styles/fitChart'
import VueAMap from 'vue-amap';
Vue.use(VueAMap);
Vue.prototype.fitChartFont = fitChartsize
Vue.use(dataV)
Vue.use(ElementUI);
Vue.config.productionTip = false
import '@/utils/flexible'
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
